import { ArrowBack, ExpandLess, ExpandMore } from '@mui/icons-material'
import { Button, Card, CardContent, Collapse, Divider, Grid, Typography } from '@mui/material'
import { LabelField } from 'components'
import { ClusterShipperDto } from 'dtos'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface ClusterShipperNeedsThirdPartyConversionDeliveryHeroCardProps {
  clusterShipper: ClusterShipperDto
}

export default function ClusterShipperNeedsThirdPartyConversionDeliveryHeroCard({
  clusterShipper
}: ClusterShipperNeedsThirdPartyConversionDeliveryHeroCardProps) {
  const navigate = useNavigate()

  const [open, setOpen] = useState(false)

  const handleOpenClick = () => {
    setOpen(prev => !prev)
  }

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} justifyContent='space-between'>
          <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm='auto' container alignItems='center' spacing={0}>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  Selected Cluster Shipper:
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={12} sm='auto' container spacing={2} alignItems='center' justifyContent='flex-end'>
              <Grid item>
                <Button
                  onClick={() => {
                    navigate('/to-do-list')
                  }}
                  color='primary'
                  startIcon={<ArrowBack />}
                  variant='text'
                >
                  BACK
                </Button>
              </Grid>

              <Grid item sx={{ alignSelf: 'stretch' }}>
                <Divider orientation='vertical' />
              </Grid>

              <Grid item>
                <Button onClick={handleOpenClick}>{open ? <ExpandLess /> : <ExpandMore />}</Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Collapse in={open} timeout='auto' unmountOnExit>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <LabelField label='Cluster Shipper# :' value={clusterShipper.clusterShipperNumber} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='# of Clusters :' value={clusterShipper.numberOfClusters} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='3rd Party Conversion Company' value={clusterShipper.clusterConversionCompany?.name} />
                </Grid>
              </Grid>
            </Collapse>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
